import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReactLoading from 'react-loading';
import Main from "../../modules/main/main";
import SfaDashboardApi from "../../services/api/sfa-dashboard";
import StatisticsCards from "./components/StatisticsCards";
import StatusBreakdown from "./components/StatusBreakdown";
import SfaTable from "./components/SfaTable";
import FilterPanel from "./components/FilterPanel";
import MonthlyTrendsChart from "./components/MonthlyTrendsChart";
import TopSchoolsChart from "./components/TopSchoolsChart";
import { toast } from 'react-toastify';
import './sfa-dashboard.scss';

function SfaDashboard() {
    const [loading, setLoading] = useState(true);
    const [dashboardData, setDashboardData] = useState(null);
    const [filters, setFilters] = useState({
        status: '',
        search: '',
        date_from: '',
        date_to: '',
        sort_by: 'created_at',
        sort_order: 'desc',
        per_page: 15,
        page: 1
    });

    const fetchDashboardData = async (currentFilters = filters) => {
        try {
            setLoading(true);
            const response = await SfaDashboardApi.getDashboard(currentFilters);
            
            if (response.success) {
                setDashboardData(response.data);
            } else {
                toast.error('Failed to load dashboard data');
            }
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
            toast.error('Error loading dashboard data');
        } finally {
            setLoading(false);
        }
    };

    const handleFilterChange = (newFilters) => {
        const updatedFilters = { ...filters, ...newFilters, page: 1 };
        setFilters(updatedFilters);
        fetchDashboardData(updatedFilters);
    };

    const handlePageChange = (page) => {
        const updatedFilters = { ...filters, page };
        setFilters(updatedFilters);
        fetchDashboardData(updatedFilters);
    };

    useEffect(() => {
        fetchDashboardData();
    }, []);

    const breadcrumbs = [
        { "link": "/", "name": "Dashboard", "active": false },
        { "link": "/sfa-dashboard", "name": "SFA Dashboard", "active": true }
    ];

    return (
        <Main title="SFA Dashboard" breadcrumbs={breadcrumbs} loading={loading}>
            <div className="sfa-dashboard">
                <div className={loading ? "overlay" : "overlay d-none"}>
                    <ReactLoading type="spin" color="black" width={'10%'} height={'10%'} />
                </div>

                {dashboardData && (
                    <>
                        {/* Statistics Cards */}
                        <div className="row">
                            <StatisticsCards statistics={dashboardData.statistics} />
                        </div>

                        {/* Status Breakdown and Charts */}
                        <div className="row">
                            <div className="col-lg-6">
                                <StatusBreakdown 
                                    statusBreakdown={dashboardData.status_breakdown}
                                    onStatusClick={(status) => handleFilterChange({ status })}
                                />
                            </div>
                            <div className="col-lg-6">
                                <MonthlyTrendsChart trends={dashboardData.monthly_trends} />
                            </div>
                        </div>

                        {/* Top Schools */}
                        <div className="row">
                            <div className="col-lg-12">
                                <TopSchoolsChart schools={dashboardData.top_schools} />
                            </div>
                        </div>

                        {/* Filters and Table */}
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">SFA Applications</h3>
                                        <div className="card-tools">
                                            <Link to="/sfa" className="btn btn-primary btn-sm">
                                                <i className="fas fa-plus"></i> New SFA
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <FilterPanel 
                                            filters={filters}
                                            onFilterChange={handleFilterChange}
                                        />
                                        
                                        <SfaTable 
                                            sfas={dashboardData.sfas}
                                            onPageChange={handlePageChange}
                                            currentPage={filters.page}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </Main>
    );
}

export default SfaDashboard; 